import { render, staticRenderFns } from "./platforms-list.vue?vue&type=template&id=00c5db04&scoped=true"
import script from "./platforms-list.vue?vue&type=script&lang=js"
export * from "./platforms-list.vue?vue&type=script&lang=js"
import style0 from "./platforms-list.vue?vue&type=style&index=0&id=00c5db04&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5db04",
  null
  
)

export default component.exports